<template>
	<v-card >
		<v-toolbar color="#D3D5D8"  dense> 
			<v-btn icon v-on:click="cerrar" > <i class="fa fa-times"></i></v-btn>
			<v-spacer></v-spacer>
			<v-card-title>{{almacen.nombre | capitalize}}</v-card-title>
		</v-toolbar>
		<v-row class="no-mp">
			<v-col class="no-mp" >
				<v-card elevation="0" outlined style="margin:10px; padding:20px; background-color:#F0F0F0;">
					<v-form ref="form">
						<v-text-field v-model="almacen.nombre"  label="Nombre" :rules="reglas.nombre"></v-text-field>
						<v-text-field v-model="almacen.descripcion" label="Descripcion"></v-text-field>
					</v-form>					
					<v-btn block color="success" v-on:click="guardar">Guardar</v-btn>
				</v-card>
			</v-col>
		</v-row>
	</v-card>
</template>

<script>
	import Schema from '../../core/Schema';
  export default {
    components:{},
    props: { 
			almacen: {
				type:Object,
				default() { return { };}
			}
		},
    data () { return { 
			reglas: {
				nombre:[
					(val) => !!val || 'Agrega un nombre'
				]
			}
		};},
		mounted() {},
    methods: {
			guardar() {
				if(!this.$refs.form.validate()) {
					//alert("Faltan agregar campos");
					return;
				}
				this.$store.commit('setsplash',{texto:'Guardando', activar: true});
				Schema.models.Almacen.guardar(this.almacen,'all',(job) => {
					this.$emit('getalmacen',job.newData);
					this.$store.commit('setsplash',{texto:'', activar: false});
				});
				
			},
			cerrar() {
				this.$emit('getalmacen',null);
			},
		},
		computed: {},
		watch: {}
  }
</script>
<style>
</style>
